import * as React from 'react';

export const IconEmojiObjectsInboxTray = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M36 32a4 4 0 01-4 4H4a4 4 0 01-4-4v-9c0-2.209.791-3 3-3h30c2.209 0 3 .791 3 3v9z"
      fill="#D99E82"
    />
    <path d="M25 20a7 7 0 11-14 0h14z" fill="#662113" />
    <path d="M4 36h28a4 4 0 004-4H0a4 4 0 004 4z" fill="#C1694F" />
    <path
      d="M26.716 8h-4.783V2a2 2 0 00-2-2h-4.001a2 2 0 00-2 2v6H9.149c-1.223 0-1.516.623-.651 1.489l7.863 7.863c.865.865 2.28.865 3.146 0l7.863-7.863c.863-.866.57-1.489-.653-1.489z"
      fill="#77B255"
    />
  </svg>
);
